import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      category: "About Our Clinic",
      question: 'What is SDORA WELLBEING?',
      answer: 'SDORA WELLBEING is an Outpatient Mental Health Clinic (OMHC) serving both adults and minors. We provide a range of therapeutic services including individual therapy, group therapy, family therapy, couples therapy, and trauma-based/trauma-informed therapy. Our warm, professional team is dedicated to supporting your mental health journey with compassion and evidence-based care.'
    },
    {
      category: "Getting Started",
      question: 'How do I know if I need therapy?',
      answer: 'Common signs include experiencing intense emotions that affect daily life, difficulty coping with stress or major life changes, trauma from abuse or violence, relationship problems, chronic illness impacting mental health, or recurring mental health symptoms. If any of these apply to you, speaking with a mental health professional can help.'
    },
    {
      category: "Getting Started",
      question: 'What is a Comprehensive Assessment?',
      answer: 'A Comprehensive Assessment is the starting point for your care with us. This evaluation helps us understand your emotional, behavioral, and mental health needs so we can determine the most appropriate recommendations and services tailored specifically to you.'
    },
    {
      category: "Getting Started",
      question: 'How does SDORA WELLBEING create my treatment plan?',
      answer: 'We collaborate with you to create an Individualized Treatment Plan based on your specific needs, preferences, and goals. Through open, respectful communication and informed decision-making, we ensure your plan reflects what matters most to you and supports your path to healing.'
    },
    {
      category: "Our Services",
      question: 'What is Trauma-Based/Trauma-Informed Therapy?',
      answer: 'Trauma-based/trauma-informed therapy is designed to address the complex and far-reaching effects of trauma on your mental and emotional wellbeing. We use evidence-based therapies, interventions, and support delivered with a deep understanding of how trauma impacts your life. We believe that the scars of the past do not define the possibilities of the future.'
    },
    {
      category: "Our Services",
      question: 'What is the Psychiatric Rehabilitation Program (PRP) for minors?',
      answer: 'Our PRP services for minors use evidence-based practices focused on mental health, resilience, self-worth, hope, recovery, healing, and personal growth. PRP counselors may also help clients access vital community resources such as health insurance, transportation, income support, food assistance, energy relief, and water assistance.'
    },
    {
      category: "Our Services",
      question: 'What are the requirements to participate in the PRP program?',
      answer: 'To be admitted into the PRP program, you must: (1) be referred by a licensed mental health professional, (2) meet medical necessity criteria required by law, including a qualifying psychiatric diagnosis, (3) be receiving ongoing care at the time of referral, and (4) plan to actively participate in treatment plans and directed activities.'
    },
    {
      category: "Our Services",
      question: 'Does SDORA WELLBEING provide Medication Management?',
      answer: 'Yes. Our licensed clinicians provide medication evaluation, prescription, monitoring, and adjustments based on your assessed needs using evidence-based practices. Our goal is to ensure your medications are safe, effective, and support your recovery.'
    },
    {
      category: "Our Services",
      question: 'What is Student Counseling?',
      answer: 'Student Counseling provides support, mentoring, and counseling for students facing academic, emotional, or personal challenges. We help address stress, anxiety, academic performance concerns, interpersonal relationships, and overall wellbeing to support educational success.'
    },
    {
      category: "Our Services",
      question: 'What is Anger Management?',
      answer: 'Anger Management helps individuals understand and express anger in healthier, non-aggressive ways. We provide practical strategies to control and express anger constructively, reducing the risk of harm to yourself or others while improving relationships and communication.'
    },
    {
      category: "Our Services",
      question: 'What is Counseling and Parenting?',
      answer: 'Counseling and Parenting supports parents and caregivers in strengthening parenting skills and understanding child development. We help improve parent-child relationships, support effective discipline strategies, and create nurturing, supportive home environments.'
    },
    {
      category: "Our Services",
      question: 'What is Social & Community Engagement?',
      answer: 'We support social and community engagement by helping clients build positive relationships, discover purpose, foster resilience, and connect with supportive groups and activities. This may include clubs, community events, volunteering, and recreational activities such as karaoke, bowling, yoga and holistic wellness, painting events, community brunches, games, cookouts, beach getaways, tours, and talent shows.'
    },
    {
      category: "Our Services",
      question: 'What is Juvenile Justice support?',
      answer: 'We provide specialized support for youth involved in the legal system through interventions and guidance that address behavioral and mental health needs. Our goals include promoting positive change, reducing recidivism, supporting rehabilitation, and helping youth successfully reintegrate into the community.'
    },
    {
      category: "Our Services",
      question: 'What happens if I need a service SDORA WELLBEING doesn\'t provide?',
      answer: 'If a needed service is outside our clinic\'s scope, we help connect you to appropriate outside specialists, services, and community resources. We provide trusted recommendations, warm handoffs, and coordination to ensure you receive the comprehensive support you need.'
    },
    {
      category: "Community Resources",
      question: 'How does SDORA WELLBEING help with Community Resources?',
      answer: 'We believe supportive community is vital to healing, recovery, and personal growth. Our team helps clients navigate life needs such as education, skills acquisition, housing, healthcare, employment, benefits, and financial stability. Support may include practical guidance, resource connection, and ongoing encouragement.'
    },
    {
      category: "Community Resources",
      question: 'What specific community support areas does SDORA WELLBEING assist with?',
      answer: 'We can help with: finding housing, applying for rental and BGE relief, applying for SSI/SSD, facing and fighting eviction, finding legal help, creating resumes, securing employment or job advancement, obtaining a GED/high school diploma/college degree/certifications, obtaining a driver\'s license, finding a primary care physician or therapist, mentorship, maintaining sobriety, substance abuse treatment, transportation to vital appointments, engaging in hobbies and interests, making important phone calls, applying for Medicaid and other benefits, obtaining affordable cell phones or tablets, and obtaining volunteer hours.'
    },
    {
      category: "Insurance & Logistics",
      question: 'What kind of insurance is required to receive services?',
      answer: 'We accept Medical Assistance (MA), Primary Adult Care (PAC), and welcome uninsured eligible individuals. We also work with most major insurance providers. Contact us to verify your specific coverage.'
    },
    {
      category: "Insurance & Logistics",
      question: 'Do you offer telehealth appointments?',
      answer: 'Yes, we offer secure telehealth appointments for your convenience. This allows you to receive care from the comfort of your home while maintaining the same quality of service as in-person visits.'
    },
    {
      category: "Insurance & Logistics",
      question: 'How quickly can I get an appointment?',
      answer: 'We strive to schedule new clients within one week of initial contact. For urgent situations, we may be able to accommodate same-week appointments. Crisis support is available 24/7 through the Suicide & Crisis Lifeline at 988.'
    },
    {
      category: "Insurance & Logistics",
      question: 'What if I need to cancel or reschedule?',
      answer: 'We understand that life happens. We ask that you provide at least 24 hours notice for cancellations or rescheduling to avoid any fees. Contact us as soon as possible if you need to change your appointment.'
    },
    {
      category: "Therapy Experience",
      question: 'Why shouldn\'t I handle this on my own?',
      answer: 'Seeking help is a sign of strength, not weakness. Mental health professionals have specialized training and experience to guide you through challenges. Taking responsibility for your mental health and seeking support is an empowering first step that can significantly improve your quality of life.'
    },
    {
      category: "Therapy Experience",
      question: 'What should I expect from my therapy sessions?',
      answer: 'Therapy sessions are personalized to your needs. You may discuss specific issues or explore general feelings and emotions. Your therapist will work with you to identify areas for change, set realistic goals, and provide strategies for both short-term and long-term success. Active participation and collaboration are important.'
    },
    {
      category: "Therapy Experience",
      question: 'Do I need to share everything?',
      answer: 'No, you control what you share. If anything makes you uncomfortable, you don\'t have to share it. Building a trusting relationship with your therapist is important, and they will work at a pace that feels comfortable and safe for you. Your comfort and safety are priorities.'
    },
    {
      category: "Therapy Experience",
      question: 'How long does a session take?',
      answer: 'Individual sessions are typically 40-50 minutes in length. However, all programs at SDORA WELLBEING are individualized and tailored to your specific goals and challenges. Some clients experience significant progress in just a few sessions, while others may benefit from ongoing therapy over several weeks or months.'
    },
    {
      category: "Therapy Experience",
      question: 'Are sessions and treatment confidential?',
      answer: 'Yes, we take your privacy very seriously. All sessions and personal information are HIPAA-compliant and legally protected. Exceptions include suspected child or elder abuse (required by law to report) or if a client presents a danger to themselves or others. Generally, information disclosed in therapy is confidential and won\'t be shared without your consent.'
    }
  ];

  // Group FAQs by category
  const categories = [...new Set(faqs.map(faq => faq.category))];

  // Generate FAQPage JSON-LD for rich snippets
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(({ question, answer }) => ({
      "@type": "Question",
      "name": question,
      "acceptedAnswer": { "@type": "Answer", "text": answer },
    })),
  };

  return (
    <section id="faq" className="py-20 bg-white" data-testid="faq-section">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Find answers to common questions about our services and getting started.
          </p>
        </div>

        {/* FAQ List by Category */}
        {categories.map((category) => (
          <div key={category} className="mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 border-b-2 border-blue-600 pb-2">
              {category}
            </h3>
            <div className="space-y-4">
              {faqs
                .filter(faq => faq.category === category)
                .map((faq, index) => {
                  const globalIndex = faqs.indexOf(faq);
                  return (
                    <div
                      key={globalIndex}
                      className="bg-white border border-gray-200 rounded-xl overflow-hidden"
                      data-testid={`faq-item-${globalIndex}`}
                    >
                      <button
                        onClick={() => setOpenIndex(openIndex === globalIndex ? null : globalIndex)}
                        className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors"
                        data-testid={`faq-question-${globalIndex}`}
                      >
                        <span className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</span>
                        {openIndex === globalIndex ? (
                          <ChevronUp className="w-5 h-5 text-blue-600 flex-shrink-0" />
                        ) : (
                          <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                        )}
                      </button>
                      {openIndex === globalIndex && (
                        <div className="px-6 pb-6" data-testid={`faq-answer-${globalIndex}`}>
                          <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        ))}

        {/* Contact CTA */}
        <div className="mt-12 text-center bg-blue-50 rounded-xl p-8">
          <p className="text-lg text-gray-700 mb-4">
            Have more questions?
          </p>
          <a
            href="tel:+18777725150"
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
